<template>
  <div class="container-app">
    <header-title />
    <div class="out-cc">
      <el-card
        class="box-card"
        style="width: 100%; margin-top: 40px; max-width: 1100px"
      >
        <template #header>
          <div class="card-header">
            <span style="font-size: 22px">文章管理</span>
          </div>
        </template>
        <div class="cell">
          <span class="all-span">文章标题</span>
          <el-input
            v-model="queryDetailData.a_title"
            placeholder="请输入标题"
            class="all-style"
            type="textarea"
            style="border: 1px solid rgb(204, 204, 204)"
            input-style="text-align: center"
          />
        </div>
        <div class="cell">
          <span class="all-span">发布日期</span>
          <el-config-provider :locale="locale">
            <el-date-picker
              class="all-style"
              v-model="queryDetailData.a_release_time"
              type="datetime"
              placeholder="请选择发布日期"
              :locale="locale"
            />
          </el-config-provider>
        </div>
        <div class="cell">
          <span class="all-span">类别</span>
          <!-- <el-cascader v-model="value" :options="options" :props="props" placeholder="请选择类别" @change="_selectChange"
            style="width: 300px;" /> -->
          <el-select
            v-model="queryDetailData.a_type"
            placeholder="请选择"
            size="large"
            style="width: 240px; min-height: 30px"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div class="cell">
          <span class="all-span">浏览次数</span>
          <el-input
            v-model="queryDetailData.a_pageviews"
            placeholder="请输入浏览次数"
            class="all-style"
            type="number"
          />
        </div>
        <div class="cell">
          <span class="all-span">作者</span>
          <el-input v-model="queryDetailData.a_author" class="all-style" />
        </div>
        <div class="cell">
          <span class="all-span">文章内容</span>
          <div class="cell-col">
            <div style="border: 1px solid #ccc">
              <Toolbar
                style="border-bottom: 1px solid #ccc"
                :editor="editorRef"
                :defaultConfig="toolbarConfig"
                :mode="mode"
              />
              <Editor
                style="height: 500px; width: 1000px; overflow-y: hidden"
                v-model="queryDetailData.a_content"
                :defaultConfig="editorConfig"
                :mode="mode"
                @onCreated="handleCreated"
              />
            </div>
          </div>
        </div>
        <div
          style="
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
          "
        >
          <div
            class="cell"
            style="
              justify-content: center;
              flex-direction: row;
              margin-bottom: 30px;
              width: 80%;
            "
          >
            <div class="bottom-con-child">
              <el-button
                @click="_upDateArticle"
                round
                size="large"
                type="primary"
                style="width: 160px"
                >提交</el-button
              >
            </div>
            <div class="bottom-con-child">
              <el-button
                @click="_close"
                round
                size="large"
                type="danger"
                style="width: 160px"
                >关闭</el-button
              >
            </div>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import '@wangeditor/editor/dist/css/style.css' // 引入 css
import { Boot } from '@wangeditor/editor'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { onBeforeUnmount, ref, shallowRef, onMounted } from 'vue'
import attachmentModule from '@wangeditor/plugin-upload-attachment'
import headerTitle from '@/components/headerTitle.vue'
import http from '@/util/http.js'
import { ElMessage } from 'element-plus'
import config from '@/util/config'

Boot.registerModule(attachmentModule)

let editorAll
let Base64 = require('js-base64').Base64
let interval

export default {
  name: 'editorView',
  components: { Editor, Toolbar, headerTitle },
  setup() {
    // 编辑器实例，必须用 shallowRef
    const editorRef = shallowRef()
    const editorConfig = { placeholder: '请输入文章内容', MENU_CONF: {} }
    // 内容 HTML
    const valueHtml = ref('')
    const toolbarConfig = {
      excludeKeys: [
        'insertLink',
        'insertImage',
        'emotion',
        'codeBlock',
        'group-video',
        'fullScreen' // 这里是从工具栏中排除的项目
      ]
    }
    // 字体
    editorConfig.MENU_CONF['fontFamily'] = {
      fontFamilyList: [
        // 元素支持两种形式
        //   1. 字符串；
        //   2. { name: 'xxx', value: 'xxx' }
        {
          name: '仿宋 GB-2312',
          value: 'fang-song'
        },
        {
          name: '黑体',
          value: 'hei-ti'
        },
        {
          name: '宋体',
          value: 'song-ti'
        },
        {
          name: '楷体',
          value: 'kai-ti'
        },
        {
          name: '阿里巴巴普惠体',
          value: 'pu-hui-ti'
        }
      ]
    }
    // 图片
    editorConfig.MENU_CONF['uploadImage'] = {
      // 地址
      server: config.url + '/imageUpload',
      fieldName: 'file',
      maxFileSize: 5 * 1024 * 1024 * 1024,
      allowedFileTypes: ['image/*'],
      withCredentials: false,
      timeout: 5000 * 1000,
      maxFileSize: 10 * 1024 * 1024,
      // 上传之前触发
      onBeforeUpload(file) {
        // file 选中的文件，格式如 { key: file }
        return file
        // 可以 return
        // 1. return file 或者 new 一个 file ，接下来将上传
        // 2. return false ，不上传这个 file
      },
      // 上传进度的回调函数
      onProgress(progress) {
        // progress 是 0-100 的数字
        console.log('progress', progress)
      },
      // 单个文件上传成功之后
      onSuccess(file, res) {
        console.log(`${file.name} 上传成功`, res)
      },
      // 单个文件上传失败
      onFailed(file, res) {
        console.log(`${file.name} 上传失败`, res)
      },
      // 上传错误，或者触发 timeout 超时
      onError(file, err, res) {
        console.log(`${file.name} 上传出错`, err, res)
      }
    }

    // 组件销毁时，也及时销毁编辑器
    onBeforeUnmount(() => {
      const editor = editorRef.value
      if (editor == null) return
      editor.destroy()
    })

    const handleCreated = editor => {
      editorRef.value = editor // 记录 editor 实例，重要！
      editorAll = editor
    }

    // const router = useRouter()
    return {
      editorRef,
      valueHtml,
      mode: 'default', // 或 'simple'
      toolbarConfig,
      editorConfig,
      handleCreated
      // props: {
      //   // props.
      //   expandTrigger: 'hover',
      //   multiple: !Object.prototype.hasOwnProperty.call(
      //     router.currentRoute.value.query,
      //     'isPublished'
      //   )
      // }
    }
  },
  data() {
    return {
      queryDetailData: {
        a_type: '',
        a_title: '',
        a_updated_time: '',
        a_release_time: '',
        a_id: '',
        a_pageviews: '',
        a_content: '',
        a_author: ''
      },
      value: '0',
      options: [
        {
          value: '0',
          label: '国家最新消息'
        },
        {
          value: '1',
          label: '当地公告'
        }
      ]
    }
  },
  mounted() {
    // this.queryId = this.$route.query.id
    this.queryDetailData.a_id = this.$route.query.id
    this._getArticle()
  },
  methods: {
    // 查找文章
    _getArticle() {
      if (!this.queryDetailData.a_id == '') {
        http.get('selDetail/' + this.queryDetailData.a_id).then(res => {
          if (res.code == 200) {
            this.value = res.data.a_type
            this.queryDetailData = res.data
            this.queryDetailData.a_id = this.$route.query.id
          }
        })
      }
    },

    isInteger(str) {
     const regPos = /^\d+$/; // 非负整数
     const regNeg = /^-\d+$/; // 负整数
     return regPos.test(str) || regNeg.test(str);
    },
    // 新增文章
    _setNewArticle() {
      if(!this.isInteger(this.queryDetailData.a_pageviews)){
        ElMessage.warning('浏览次数必须为数字')
        return 
      }
      http.post('article/', this.queryDetailData).then(res => {
        if (res.code == 200) {
          ElMessage.success('提交成功')
          this.$router.go(-1)
        }else {
          ElMessage.warning(res.description)
        }
      })
    },
    // 提交修改
    _upDateArticle() {
      if (!this.$route.query.id) {
        this._setNewArticle()
      } else {
        if(!this.isInteger(this.queryDetailData.a_pageviews)){
          ElMessage.warning('浏览次数必须为数字')
          return 
        }
        http.post('updateArticle/', this.queryDetailData).then(res => {
          if (res.code == 200) {
            ElMessage.success('修改成功')
            this.$router.go(-1)
          }
          else {
            ElMessage.warning(res.description)
          }
        })
      }
    },
    // 关闭当前页
    _close() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.all-style .el-input__inner {
  border: 0;
  color: #333333;
}

span {
  font-weight: bold;
}
.wang-editor .w-e-text-container img {
  max-width: 100%; /* 限制图片宽度最大为容器宽度 */
  height: auto; /* 保持图片的宽高比 */
}
.cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.bottom-con-child {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 10px;
}

.cell-col {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex: 1;
}

.all-span {
  /*margin-right: 30px;*/
  width: 100px;
  text-align: start;
  margin-bottom: 10px;
}

.all-style {
  display: flex;
  flex: 1;
}

.out-cc {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
}

.out-cc video {
  width: 100%;
  max-height: 720px;
}

.out-cc .el-upload__input {
  display: none;
}
</style>
